function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import './button.scss';
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { defaultColors } from './Constants';
import ContentWrapper from './ContentWrapper';
import { Spinner, Label, Avatar, Icon, useTheme } from '..';
const Button = _ref => {
  let {
    active,
    activeDropDownItem,
    additionalSubTitle,
    btnType,
    children,
    className,
    color,
    customContentElement,
    customWrapComponent,
    dataName,
    defaultTheme,
    description,
    disabled,
    disabledDropdownItem,
    download,
    iconClassName,
    iconName,
    imgSrc,
    isMobileApp,
    label,
    labelColor,
    linkOutside,
    loading,
    name,
    onClick,
    onFocus,
    onMouseDown,
    small,
    subTitle,
    symbol,
    tabIndex,
    title,
    type,
    ...rest
  } = _ref;
  const {
    theme
  } = useTheme();
  const componentTheme = defaultTheme || theme;
  const baseColor = defaultColors[type];
  const _className = classNames(`wrts-btn-${type}`, {
    disabled,
    loading,
    small,
    active: active || loading,
    'active-dropdown-item': activeDropDownItem,
    'disabled-dropdown-item': disabledDropdownItem
  }, color || baseColor, className, description ? 'sub-desc' : null, componentTheme);
  const Content = () => /*#__PURE__*/React.createElement(React.Fragment, null, customContentElement && customContentElement(), iconName && type !== 'add' && !symbol && !customContentElement && /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    className: classNames(iconClassName, {
      'with-description': description
    })
  }), type === 'add' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    name: "add"
  }), /*#__PURE__*/React.createElement(Icon, {
    name: "check"
  }), /*#__PURE__*/React.createElement(Icon, {
    name: "close"
  })), imgSrc && /*#__PURE__*/React.createElement(Avatar, {
    image: imgSrc
  }), title && !subTitle && !description && /*#__PURE__*/React.createElement("span", {
    className: "text"
  }, title), title && description && /*#__PURE__*/React.createElement("div", {
    className: "desc-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "info-block"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text"
  }, title), !!label && /*#__PURE__*/React.createElement(Label, {
    color: labelColor,
    title: label
  })), /*#__PURE__*/React.createElement("span", {
    className: "text desc"
  }, description)), title && subTitle && !description && /*#__PURE__*/React.createElement("div", {
    className: "desc-block"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text"
  }, title), /*#__PURE__*/React.createElement("span", {
    className: "text sub-text"
  }, subTitle), additionalSubTitle && /*#__PURE__*/React.createElement("span", {
    className: "text sub-text"
  }, additionalSubTitle)), loading && /*#__PURE__*/React.createElement(Spinner, null), activeDropDownItem && /*#__PURE__*/React.createElement(Icon, {
    name: "check",
    className: "dropdown-check"
  }), symbol && /*#__PURE__*/React.createElement("span", {
    className: "symbol"
  }, symbol), !!label && !description && /*#__PURE__*/React.createElement(Label, {
    color: labelColor,
    title: label
  }), children);
  const getContent = /*#__PURE__*/React.createElement(ContentWrapper, {
    btnType: type
  }, /*#__PURE__*/React.createElement(Content, null));
  return /*#__PURE__*/React.createElement(React.Fragment, null, linkOutside && /*#__PURE__*/React.createElement("a", _extends({}, rest, {
    onClick: isMobileApp ? () => window.open(linkOutside, '_system') : undefined,
    href: !isMobileApp ? linkOutside : undefined,
    className: _className,
    rel: "noopener noreferrer",
    download: download,
    target: "_blank",
    "data-name": dataName
  }), getContent), customWrapComponent && customWrapComponent(getContent, _className), !linkOutside && !customWrapComponent && /*#__PURE__*/React.createElement("button", _extends({}, rest, {
    className: _className,
    onClick: disabled || loading || disabledDropdownItem ? undefined : onClick,
    tabIndex: tabIndex,
    onFocus: disabled || loading || disabledDropdownItem ? undefined : onFocus,
    onMouseDown: disabled || loading || disabledDropdownItem ? undefined : onMouseDown,
    type: btnType,
    name: name,
    "data-name": dataName
  }), getContent));
};
Button.defaultProps = {
  type: 'primary',
  tabIndex: -1,
  btnType: 'submit',
  name: ''
};
Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  linkOutside: PropTypes.string,
  iconName: PropTypes.string,
  link: PropTypes.string,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  small: PropTypes.bool,
  title: PropTypes.string,
  btnType: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.oneOf(['primary', 'add', 'char', 'link', 'menu', 'icon-link', 'close', 'social', 'simple-link', 'flat', 'filter']),
  download: PropTypes.bool
};
export default /*#__PURE__*/memo(Button);